
import { ElForm, ElMessage, ElMessageBox } from 'element-plus'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import Container from '@/components/form/container/Container.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import CenterForm from '@/components/form/common/CenterForm.vue'
import NomalContainer from '@/components/dfms-components/container/NomalContainer.vue'
import {
  ApplicationPrintersModel,
  ApplicationPrintersPageSearchModel,
  ApplicationPrintersSearchModel,
  ApplicationPrintersAddModel,
  ApplicationPrintersUpdateModel,
  IdsModel
} from '@/model/product/ApplicationPrintersModel'
import {
  pageSearchApplicationPrinters,
  addApplicationPrinters,
  updateApplicationPrinters,
  removeApplicationPrinters,
  batchRemoveApplicationPrinters
} from '@/apis/product/applicationPrinters'
import { parseTime } from '@/utils'
import { createModel } from '@/utils/component'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: {
    Container,
    SearchForm,
    SimpleTable,
    CenterForm,
    NomalContainer
  },
  setup() {
    const { t } = useI18n()
    const searchFormRef = ref(ElForm)
    const searchStruct = [
      // { prop: 'printerId', label: t('applicationPrinters.printerId'), placeholder: t('applicationPrinters.printerIdP'), component: 'el-input', type: 'number', model: null },
      { prop: 'printerName', label: t('applicationPrinters.printerName'), placeholder: t('applicationPrinters.printerNameP'), component: 'el-input', type: 'text', model: null },
      // { prop: 'appId', label: t('applicationPrinters.appId'), placeholder: t('applicationPrinters.appIdP'), component: 'el-input', type: 'number', model: null },
      { prop: 'appName', label: t('applicationPrinters.appName'), placeholder: t('applicationPrinters.appNameP'), component: 'el-input', type: 'text', model: null }
    ]

    const createStruct = [
      { prop: 'printerId', label: t('applicationPrinters.printerId'), placeholder: t('applicationPrinters.printerIdP'), component: 'el-input', type: 'number', model: null },
      { prop: 'printerName', label: t('applicationPrinters.printerName'), placeholder: t('applicationPrinters.printerNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'appId', label: t('applicationPrinters.appId'), placeholder: t('applicationPrinters.appIdP'), component: 'el-input', type: 'number', model: null },
      { prop: 'appName', label: t('applicationPrinters.appName'), placeholder: t('applicationPrinters.appNameP'), component: 'el-input', type: 'text', model: null }
    ]

    const updateStruct = [
      { prop: 'printerId', label: t('applicationPrinters.printerId'), placeholder: t('applicationPrinters.printerIdP'), component: 'el-input', type: 'number', model: null },
      { prop: 'printerName', label: t('applicationPrinters.printerName'), placeholder: t('applicationPrinters.printerNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'appId', label: t('applicationPrinters.appId'), placeholder: t('applicationPrinters.appIdP'), component: 'el-input', type: 'number', model: null },
      { prop: 'appName', label: t('applicationPrinters.appName'), placeholder: t('applicationPrinters.appNameP'), component: 'el-input', type: 'text', model: null }
    ]

    const applicationPrintersRole = {
      printerId: [{ required: true, message: t('applicationPrinters.printerId').concat(t('common.isRequired')), trigger: 'blur' }],
      printerName: [{ required: true, message: t('applicationPrinters.printerName').concat(t('common.isRequired')), trigger: 'blur' }],
      appId: [{ required: true, message: t('applicationPrinters.appId').concat(t('common.isRequired')), trigger: 'blur' }],
      appName: [{ required: true, message: t('applicationPrinters.appName').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const tableStruct = [

      { prop: 'printerId', label: t('applicationPrinters.printerId'), sortable: 'custom' },
      { prop: 'printerName', label: t('applicationPrinters.printerName'), sortable: 'custom' },
      { prop: 'appId', label: t('applicationPrinters.appId'), sortable: 'custom' },
      { prop: 'appName', label: t('applicationPrinters.appName'), sortable: 'custom' },
      { prop: 'createTime', label: t('common.createTime'), formatter: (row: ApplicationPrintersModel) => { return parseTime(row.createTime) }, sortable: 'custom' },
      { prop: 'updateTime', label: t('common.updateTime'), formatter: (row: ApplicationPrintersModel) => { return parseTime(row.updateTime) }, sortable: 'custom' }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as ApplicationPrintersSearchModel,
      tableData: Array<ApplicationPrintersModel>(),
      columnStruct: tableStruct,
      listLoading: true,
      selection: Array<number>(),
      limit: 10,
      total: 0,
      page: 1,
      sort: 'createTime',
      order: 'desc',
      dialogStatus: 'create',
      textMap: {
        update: 'applicationPrinters.edit',
        create: 'applicationPrinters.create'
      },
      dialogFormVisible: false,
      applicationPrintersRole: applicationPrintersRole,
      createStruct: createStruct,
      createModel: createModel(createStruct) as ApplicationPrintersAddModel,
      updateStruct: updateStruct,
      updateModel: createModel(updateStruct) as ApplicationPrintersUpdateModel,
      editRow: {} as ApplicationPrintersModel,
      handleSelection(item: any[]) {
        dataMap.selection = item
      },
      handleCurrentChange(page?: any) {
        dataMap.page = page
        dataMap.getList()
      },
      handleSizeChange(val: any) {
        dataMap.limit = val
        dataMap.getList()
      },
      handleOrder(column: any) {
        dataMap.sort = column.prop
        dataMap.order = column.order === 'descending' ? 'desc' : 'asc'
        dataMap.getList()
      },
      async getList() {
        dataMap.listLoading = true
        const params: ApplicationPrintersPageSearchModel = {
          printerId: dataMap.searchFormModel.printerId,
          printerName: dataMap.searchFormModel.printerName,
          appId: dataMap.searchFormModel.appId,
          appName: dataMap.searchFormModel.appName,
          page: dataMap.page,
          limit: dataMap.limit,
          sort: dataMap.sort,
          order: dataMap.order
        }
        const data = await pageSearchApplicationPrinters(params)
        dataMap.tableData = data?.data?.records ?? []
        const total = data?.data?.total ?? '0'
        dataMap.total = parseInt(total)

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      submitSearch() {
        dataMap.page = 1
        dataMap.getList()
      },
      resetForm() {
        console.log('reset')
      },
      async createSubmit() {
        const createData: ApplicationPrintersAddModel = {
          printerId: dataMap.createModel.printerId,
          printerName: dataMap.createModel.printerName,
          appId: dataMap.createModel.appId,
          appName: dataMap.createModel.appName
        }
        const result = await addApplicationPrinters(createData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.createSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async updateNameSubmit() {
        const updateData: ApplicationPrintersUpdateModel = {
          id: dataMap.updateModel.id,
          printerId: dataMap.updateModel.printerId,
          printerName: dataMap.updateModel.printerName,
          appId: dataMap.updateModel.appId,
          appName: dataMap.updateModel.appName
        }
        const result = await updateApplicationPrinters(updateData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async deleteData(id: number) {
        const result = await removeApplicationPrinters(id)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async bathDeleteData() {
        const deleteData: IdsModel = { ids: dataMap.selection }
        const result = await batchRemoveApplicationPrinters(deleteData)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      updateNameReset() {
        console.log('update reset')
        dataMap.updateModel.id = dataMap.editRow.id
        dataMap.updateModel.printerId = dataMap.editRow.printerId
        dataMap.updateModel.printerName = dataMap.editRow.printerName
        dataMap.updateModel.appId = dataMap.editRow.appId
        dataMap.updateModel.appName = dataMap.editRow.appName
      },
      createReset() {
        console.log('create reset')
      }
    })
    const handleCreate = () => {
      dataMap.dialogStatus = 'create'
      dataMap.dialogFormVisible = true
    }
    const handleEdit = (row?: ApplicationPrintersModel) => {
      if (row) {
        dataMap.editRow = row
        dataMap.dialogStatus = 'update'
        dataMap.updateModel.id = row.id
        dataMap.updateModel.printerId = row.printerId
        dataMap.updateModel.printerName = row.printerName
        dataMap.updateModel.appId = row.appId
        dataMap.updateModel.appName = row.appName
        dataMap.dialogFormVisible = true
      }
    }
    const handleDelete = (id: number) => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.deleteData(id)
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleBathDelete = () => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.bathDeleteData()
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    onMounted(() => {
      dataMap.getList()
    })
    return {
      t,
      handleCreate,
      handleEdit,
      handleDelete,
      handleBathDelete,
      searchFormRef,
      ...toRefs(dataMap)
    }
  }
})
